export class RefundStatusLookup {
    ticketNumber?: string;
    firstName?: string;
    lastName?: string;
}
